export enum SortBy {
    CREATED = 'created',
    NAME = 'name',
}
